import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import supabase from "../config/supabaseClient";
import '../CreateTalkArchive.css'; // Import the CSS file

const Create_Internal_Scouting = () => {
  const navigate = useNavigate();

  const [type, setType] = useState('');
  const [playerName, setPlayerName] = useState('');
  const [playerId, setPlayerId] = useState('');
  const [Name, setName] = useState('');
  const [Date, setDate] = useState('');
  const [coment, setcoment] = useState('');
  const [formError, setFormError] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [selectedPlayerId, setSelectedPlayerId] = useState(null);

  useEffect(() => {
    const fetchSuggestions = async () => {
      if (playerName) {
        const { data, error } = await supabase
          .from('players')
          .select('id, Name')
          .ilike('Name', `%${playerName}%`); // Case-insensitive search

        if (error) {
          console.error('Error fetching player suggestions:', error);
          return;
        }
        setSuggestions(data || []);
      } else {
        setSuggestions([]);
      }
    };

    fetchSuggestions();
  }, [playerName]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate inputs
    if ( !Date || !coment) {
      setFormError('Please fill in all required fields.');
      return;
    }

    // Use selectedPlayerId if type is 'player'
    const playerIdNumber =  selectedPlayerId;

    try {
      const { data, error } = await supabase
        .from('internal_scouting') // Ensure this matches your actual table name
        .insert([{
          player_id: playerIdNumber,
          Date,
          coment
        }]);

      if (error) {
        console.error('Supabase error:', error);
        setFormError('Error inserting the data. ' + (error.message || 'Unknown error'));
      } else {
        console.log('Insert successful:', data);
        setFormError(null);
        navigate('/scouting', { replace: true });
      }
    } catch (err) {
      console.error('Unexpected error:', err);
      setFormError('Unexpected error occurred. ' + (err.message || 'Unknown error'));
    }
  };

  return (
    <div className="page create">
      <form onSubmit={handleSubmit}>

          <div className="form-group">
            <label htmlFor="playerName">Player Name:</label>
            <input
              type="text"
              id="playerName"
              value={playerName}
              onChange={(e) => {
                setPlayerName(e.target.value);
                setSelectedPlayerId(null); // Reset selected player ID on name change
              }}
            />
              <ul className="suggestions-list">
                {suggestions.map((suggestion) => (
                  <li
                    key={suggestion.id}
                    onClick={() => {
                      setPlayerName(suggestion.Name);
                      setSelectedPlayerId(suggestion.id);
                      setPlayerId(suggestion.id);
                      setSuggestions([]); // Clear suggestions after selection
                    }}
                  >
                    {suggestion.Name}
                  </li>
                ))}
              </ul>
          </div>

        {(type === 'parent' || type === 'coach' || type === 'director') && (
          <div className="form-group">
            <label htmlFor="Name">Name:</label>
            <input
              type="text"
              id="Name"
              value={Name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
        )}

        <div className="form-group">
          <label htmlFor="Date">Date:</label>
          <input
            type="date"
            id="Date"
            value={Date}
            onChange={(e) => setDate(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="coment">Coment:</label>
          <textarea
            id="coment"
            value={coment}
            onChange={(e) => setcoment(e.target.value)}
          />
        </div>

        <div className="form-group">
          <button type="submit">Submit</button>
        </div>

        {formError && <p className="error">{formError}</p>}
      </form>
    </div>
  );
};

export default Create_Internal_Scouting;
